<template>
  <div class="users-out">
    <CDNTabs :tabs="tabs" />
    <div class='users-manage'>
      <div class="menu-title">
        <!-- <span>{{$t('handleLog.logList')}}</span> -->
        <div class="menu-right">
         <div class="filter-container" @click="filterClick">
          <CDNButton
           :BtnText="$t('common.filter')"
           :hasBg="isFilter"
           :imgPath="require('@/assets/images/products/icon_filter.png')"
            />
            <CDNButton
              :hasBg="isFilter"
              :imgPath="require('@/assets/images/products/icon_down.png')"
              innerstyle="margin-left: 5px;"
            />
        </div>
          <CDNButton
           :BtnText="$t('common.refresh')"
           :imgPath="require('@/assets/images/products/icon_refresh.png')"
           innerstyle="margin-left: 24px;"
           @btnclick="refresh"
            />

        </div>
      </div>
      <div v-show="isFilter" class="input-container">
      <CDNDatePicker
        ref=createdate
        :label="$t('product.createDate')"
       innerStyle="width: 288px; margin-left: 24px;"
       type="daterange"
       @changeDate="date => createDate = date"
       />
      </div>

      <div class="search-btn-content" v-show="isFilter">
        <CDNButton
         :hasBg="true"
          :imgPath="require('@/assets/images/products/prod_icon_search.png')"
          innerstyle="padding: 6px 20px;"
          :BtnText="$t('common.search')"
          @btnclick="searchClick"
           />
           <CDNButton
          :imgPath="require('@/assets/images/products/prod_icon_reset.png')"
          innerstyle="margin-left: 20px;padding: 6px 20px;"
          :BtnText="$t('common.reset')"
          @btnclick="resetClick"
           />
      </div>

      <!-- 列表 -->
      <!--  -->
      <el-table
       :data="tableData"
       style="width: 100%"
    @selection-change="selectedRows"
    >
        <el-table-column
          align="center"
          prop="host"
          :label="$t('handleLog.name')"
        >
        </el-table-column>
        
        <el-table-column
          align="center"
          prop="description"
          :label="$t('handleLog.desc')"
        >
        </el-table-column>
        
        <el-table-column
          align="center"
          prop="value"
          :label="$t('handleLog.modify')"
        >
        </el-table-column>
        
        <el-table-column
          align="center"
          prop="ip"
          label="IP"
        >
        </el-table-column>
        
        <el-table-column
          align="center"
          prop="created_at"
          :label="$t('handleLog.operDate')"
        >
        </el-table-column>
      </el-table>
      <!--  -->
       
      <div class="pagination-bottom">
        <Pagination
        :total="total"
        :page-size="pageSize"
        :page-count="pageCount"
        @change="handleChange"
      />
      </div>
      <!-- 列表 -->

  </div>
  </div>

</template>

<script>
/* eslint-disable */
import { operLogList } from '@/service/requestRes';
export default {
  data() {
    return {
      isFilter: false,
      addUseShow: false,
      createDate: '',
      tableData: [],
      total: 0,
      pageSize: 10,
      pageCount: 1,
      selectItems: [],
    };
  },
  computed: {
    headerLables() {
      return [
        { label: this.$t('handleLog.name'), value: 'host' },
        { label: this.$t('handleLog.desc'), value: 'description' },
        { label: this.$t('handleLog.modify'), value: 'value' },
        { label: 'IP', value: 'ip' },
        { label: this.$t('handleLog.operDate'), value: 'created_at' },
      ];
    },
    tabs() {
      return [this.$t('handleLog.logList')];
    },
  },
  mounted() {
    this.getLoginLogList({page: 1});
  },
  methods: {
     getLoginLogList({
      page, start_date, end_date,
    }) {
      operLogList({
        page,
          limit: this.pageSize,
          start_date,
          end_date,
      }).then(res => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          const { list } = data || {};
          const { total } = list || {};
          this.total = total;
          this.tableData = list.data;
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      })
    },
    handleChange(e) {
      this.getLoginLogList({ page: e });
    },
    selectedRows(items) {
      this.selectItems = items;
    },
    refresh() {
      this.getLoginLogList({page: 1});
    },
    filterClick() {
      this.isFilter = !this.isFilter;
    },
    editClick(item) {
      console.log(item);
    },

    searchClick() {
       let start = '';
      let end = '';
      if (this.createDate && this.createDate.length == 2) {
        start = this.createDate[0];
        end = this.createDate[1];
      }
      this.getLoginLogList({page: 1, start_date: start, end_date: end});
    },
    resetClick() {
      this.$refs.createdate.changeDate('');
    },
  },
};
</script>
<style lang="scss" scoped>
.users-out {
  width: 1276px;
  margin: 24px auto;
}
  .users-manage {
    background-color: white;
    padding: 0 24px 24px 24px;
    border-radius: 4px;
    .menu-title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      span {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #5A607F;
      }
      .menu-right {
        height: 60px;
        display: flex;
        align-items: center;
      }
    }
    .filter-container {
      display: flex;
      align-items: center;
    }
    .input-container {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
    }
    .search-btn-content {
      display: flex;
      margin-bottom: 49px;
    }
    .user-handle {
      display: flex;
      align-items: center;
      :first-child {
        margin-right: 10px;
        width: 16px;
        height: 16px;
      }
      :last-child {
        width: 18px;
        height: 19px;
      }
    }
  }
</style>
